"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REGISTER_FORM_KEY = exports.PROMOTION_KEY = exports.FORM_KEY = exports.FORCE_REDIRECTS_URL_KEY = exports.CUSTOMER_KEY = void 0;
// 推广携带的推广码
const PROMOTION_KEY = exports.PROMOTION_KEY = 'promotionKey';
const REGISTER_FORM_KEY = exports.REGISTER_FORM_KEY = 'register_from_';
const FORCE_REDIRECTS_URL_KEY = exports.FORCE_REDIRECTS_URL_KEY = 'forceRedirectsUrl';
const FORM_KEY = exports.FORM_KEY = 'from';
const CUSTOMER_KEY = exports.CUSTOMER_KEY = {
  NEW: 1,
  // 新客户
  OLD: 2 // 老客户
};